import React, {createContext} from "react";

// set the defaults
const LanguageContext = createContext("lv-LV");

export default LanguageContext;
